import type { ISocialBindsResponse } from 'reactApp/api/axios.corsapi.types';

export interface GetSocialBindsRequesSuccessAction {
    socialBinds: ISocialBindsResponse;
}

export const enum UserSocialBindType {
    vkid = 'vkid',
    unknown = 'unknown',
}

export interface UserSocialBind {
    type: UserSocialBindType;
    login: string;
    loginParsed: string;
    firstName: string;
    lastName: string;
}

export interface UserSocialBindsState {
    accounts: UserSocialBind[];
    isLoading: boolean;
    isLoaded: boolean;
    hasError: boolean;
}
